import type { SVGProps } from "react";
export interface HotWaterIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HotWaterIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HotWaterIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.972 9.957a1.78 1.78 0 0 1 2.055 0l.126.1.179.146c.44.343 1.042.673 1.668.673h1a1.125 1.125 0 0 1 0 2.25h-1c-1.297 0-2.355-.62-3.001-1.112-.646.493-1.702 1.111-2.998 1.112-1.298 0-2.356-.62-3.002-1.112-.646.493-1.702 1.111-2.999 1.112-1.297 0-2.355-.62-3.001-1.112-.646.493-1.702 1.111-2.999 1.112H2a1.125 1.125 0 0 1 0-2.25h1c.716 0 1.398-.43 1.846-.82l.126-.099a1.78 1.78 0 0 1 2.055 0l.126.1.179.146c.44.343 1.042.673 1.668.673.716 0 1.398-.43 1.846-.82l.126-.099a1.78 1.78 0 0 1 2.055 0l.126.1.179.146c.44.343 1.042.673 1.668.673.716 0 1.398-.43 1.846-.82zM6.556.967a1.125 1.125 0 1 1 .889 2.066l-.034.014c.008-.003-.008 0-.022.037a.17.17 0 0 0 .002.122l.301.736c.441 1.078.046 2.384-.997 2.97l-.217.107-.034.014a1.125 1.125 0 0 1-.889-2.067l.034-.014.022-.035a.2.2 0 0 0 .01-.062l-.012-.062-.301-.736c-.47-1.15.01-2.559 1.214-3.077zm5.499 0a1.125 1.125 0 0 1 .89 2.066l-.035.014c.01-.003-.006-.001-.02.037a.17.17 0 0 0 .001.122l.3.736.078.219c.308 1.03-.1 2.204-1.074 2.75l-.216.108-.034.014-.109.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.035a.2.2 0 0 0 .013-.062l-.012-.062-.302-.736c-.47-1.15.01-2.559 1.213-3.077zm5.609-.04a1.125 1.125 0 0 1 .78 2.106l-.033.014c.008-.003-.006 0-.02.037a.17.17 0 0 0 0 .122l.3.736.079.219c.308 1.03-.101 2.204-1.074 2.75l-.217.108-.035.014-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.035a.2.2 0 0 0 .01-.062l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.212-3.077l.034-.013z"
      />
      <path
        fill={color}
        d="M.875 19V8a1.125 1.125 0 0 1 2.25 0v11c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875V8a1.125 1.125 0 0 1 2.25 0v11A4.125 4.125 0 0 1 19 23.125H5A4.125 4.125 0 0 1 .875 19"
      />
    </svg>
  );
}
